import { render, staticRenderFns } from "./SlugField.vue?vue&type=template&id=32b95f74"
import script from "./SlugField.vue?vue&type=script&lang=js"
export * from "./SlugField.vue?vue&type=script&lang=js"
import style0 from "./SlugField.vue?vue&type=style&index=0&id=32b95f74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports